import React from "react"
import { useIsLangEN } from "../hooks"
import classnames from "classnames"

const Paragraph = props => {
  const isLangEN = useIsLangEN()
  return (
    <p
      className={classnames(
        {
          paragraph: true,
          "paragraph--en": isLangEN,
        },
        props.className
      )}
    >
      {props.children}
    </p>
  )
}

export default Paragraph
